import React, { useEffect } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'
import { trackRoutePageEvent as segmentRoutePageEvent } from '@api/segment'

const Section = styled.section`
  display: flex;
  justify-content: center;
`

/**
 * layout for the app Components that reside in the Router
 */

const Layout: React.FC = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    /* SEGMENT */
    segmentRoutePageEvent(location.pathname)
  }, [location])

  return <Section>{children}</Section>
}

export default Layout
